/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 */
import { addLocaleData } from 'react-intl';
import enLocaleData from 'react-intl/locale-data/en';
import viLocaleData from 'react-intl/locale-data/vi';
import frLocaleData from 'react-intl/locale-data/fr';
import esLocaleData from 'react-intl/locale-data/es';

import { DEFAULT_LOCALE } from '../app/containers/App/constants';

import enTranslationMessages from './locales/en/translation.json';
import viTranslationMessages from './locales/vi/translation.json';
import frTranslationMessages from './locales/fr/translation.json';
import esTranslationMessages from './locales/es/translation.json';

addLocaleData(enLocaleData);
addLocaleData(viLocaleData);
addLocaleData(frLocaleData);
addLocaleData(esLocaleData);

export const appLocales = [
  'en',
  'vi',
  'fr',
  'es',
];

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages = locale !== DEFAULT_LOCALE
    ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
    : {};
  return Object.keys(messages).reduce((formattedMessages, key) => {
    const formattedMessage = !messages[key] && locale !== DEFAULT_LOCALE
      ? defaultFormattedMessages[key]
      : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  }, {});
};

export const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
  vi: formatTranslationMessages('vi', viTranslationMessages),
  fr: formatTranslationMessages('fr', frTranslationMessages),
  es: formatTranslationMessages('es', esTranslationMessages),
};



// WEBPACK FOOTER //
// ./app/i18n.js